export default __webpack_public_path__ + "static/projects-f542285a9e3b1d26173e9a84bf8379af.jpg";